export default "__VITE_ASSET__BpQlvvlP__"